module.exports = __webpack_public_path__ + "img/spain.9441a3f6.png";